import { clsx } from 'clsx'

import { FC } from 'react'

import { SignUpCallComponent } from '@/app/shared/components/modals/sign-up-call'
import { IClassName } from '@/app/shared/interfaces/common.interface'
import useModal from '@/app/shared/store/modals.store'
import { ButtonComponent } from '@/app/shared/ui/button'
import { t } from '@/core/lib/locale/i18n'

// interface
interface IBtnCall extends IClassName {
  callback?: () => void
  text?: string
  colorType?: 'success' | 'secondary'
}

// component
const BtnCallComponent: FC<Readonly<IBtnCall>> = ({ className, callback, text, colorType }) => {
  const open = useModal((state) => state.open)

  const handleOpenModalSignUp = () => {
    if (callback) callback()

    open({
      component: SignUpCallComponent,
      props: {
        title: text ?? t.order_call(),
      },
    })
  }

  return (
    <ButtonComponent
      color={colorType ?? 'success'}
      size={'lg'}
      onClick={handleOpenModalSignUp}
      className={clsx('mx-auto', className)}
    >
      {text ?? t.order_call()}
    </ButtonComponent>
  )
}

export default BtnCallComponent
